'use es6';

import { Map as ImmutableMap } from 'immutable';
import Actions from 'AdsUI/lib/Actions';
import AdAccountPermissionsRecord from 'AdsUI/records/ad-accounts/AdAccountPermissionsRecord';

const AllPermissionsReducer = (state = ImmutableMap(), action) => {
  switch (action.type) {
    case Actions.ALL_PERMISSIONS_FETCH_SUCCEEDED:
      {
        return (action.payload || []).reduce((permMap, accountPerms) => {
          const {
            adNetwork,
            adAccountId,
            permissions,
            hubSpotUserId,
            networkUserId
          } = accountPerms;
          return permMap.setIn([adNetwork, adAccountId, networkUserId], new AdAccountPermissionsRecord(Object.assign({}, permissions, {
            hubSpotUserId,
            networkUserId
          })));
        }, ImmutableMap());
      }

    default:
      {
        return state;
      }
  }
};

export default AllPermissionsReducer;